import { TAG_COLORS } from '@OpsWb/constants'

import { EXCEPTION_STATUS, PRODUCTION_TABS } from '../constants'
import colors from '~/styles/_colors.css'

export const SALES_ORDER_PLACEMENT = 'sales-order-details'

export const ExceptionSortMapping: { [key: string]: string } = {
    name_ascend: 'NAME_ASC',
    name_descend: 'NAME_DESC',
    salesOrderName_ascend: 'SALE_ORDER_NAME_ASC',
    salesOrderName_descend: 'SALE_ORDER_NAME_DESC',
    workOrderName_ascend: 'WORK_ORDER_NAME_ASC',
    workOrderName_descend: 'WORK_ORDER_NAME_DESC',
    mpName_ascend: 'MP_NAME_ASC',
    mpName_descend: 'MP_NAME_DESC',
    type_ascend: 'TYPE_ASC',
    type_descend: 'TYPE_DESC',
    exceptionState_ascend: 'STATUS_ASC',
    exceptionState_descend: 'STATUS_DESC',
    action_ascend: 'EXCEPTION_ACTION_ASC',
    action_descend: 'EXCEPTION_ACTION_DESC',
    assignee_ascend: 'ASSIGNEE_ASC',
    assignee_descend: 'ASSIGNEE_DESC',
    updatedAt_ascend: 'UPDATED_AT_ASC',
    updatedAt_descend: 'UPDATED_AT_DESC',
    jobName_ascend: 'JOB_REQUEST_NAME_ASC',
    jobName_descend: 'JOB_REQUEST_NAME_DESC',
}

export const MAX_NAME_LENGTH = 30

export const PLACEMENT = 'exception-details'

export const EXCEPTION_FAILURE_FILTER_TYPE = {
    EXCEPTION_STATES: `${PRODUCTION_TABS.exceptions}_exceptionState`,
    EXCEPTION_TYPE: `${PRODUCTION_TABS.exceptions}_exceptionType`,
    ASSIGNEE: `${PRODUCTION_TABS.exceptions}_assignees`,
    ACTIONS: `${PRODUCTION_TABS.exceptions}_actions`,
    INTERNAL_FAILURE: `${PRODUCTION_TABS.exceptions}_internalFailureValues`,
    EXTERNAL_FAILURE: `${PRODUCTION_TABS.exceptions}_externalFailureValues`,
    SHIP_DATE: `${PRODUCTION_TABS.exceptions}_shipDate`,
    SHIP_DATE_START: `${PRODUCTION_TABS.exceptions}_shipDateStart`,
    SHIP_DATE_END: `${PRODUCTION_TABS.exceptions}_shipDateEnd`,
    DELIVERY_DATE: `${PRODUCTION_TABS.exceptions}_deliveryDate`,
    DELIVERY_DATE_START: `${PRODUCTION_TABS.exceptions}_deliveryDateStart`,
    DELIVERY_DATE_END: `${PRODUCTION_TABS.exceptions}_deliveryDateEnd`,
    JOB_REQUEST_DATE: `${PRODUCTION_TABS.exceptions}_workOrderRequestDate`,
    JOB_REQUEST_DATE_START: `${PRODUCTION_TABS.exceptions}_workOrderRequestDateStart`,
    JOB_REQUEST_DATE_END: `${PRODUCTION_TABS.exceptions}_workOrderRequestDateEnd`,
    RECEIPT_DATE: `${PRODUCTION_TABS.exceptions}_workOrderReceiptDate`,
    RECEIPT_DATE_START: `${PRODUCTION_TABS.exceptions}_workOrderReceiptDateStart`,
    RECEIPT_DATE_END: `${PRODUCTION_TABS.exceptions}_workOrderReceiptDateEnd`,
    CREATED_BY: `${PRODUCTION_TABS.exceptions}_createdBy`,
    CAR: `${PRODUCTION_TABS.exceptions}_car`,
    MFG_DRI: `${PRODUCTION_TABS.exceptions}_mfgDri`,
    FAILURE_TYPE: `${PRODUCTION_TABS.exceptions}_failuresType`,
    SALES_ORDER: `${PRODUCTION_TABS.exceptions}_salesOrder`,
    JOB_REQUEST: `${PRODUCTION_TABS.exceptions}_jobRequest`,
    MP_NAME: `${PRODUCTION_TABS.exceptions}_mp`,
    EXCEPTION: `${PRODUCTION_TABS.exceptions}_exception`,
    JOB_STATES: `${PRODUCTION_TABS.exceptions}_jobStates`,
    CUSTOMER_MFG_DRI: `${PRODUCTION_TABS.exceptions}_customerMfgDri`,
    BUSINESS_UNIT: `${PRODUCTION_TABS.exceptions}_businessUnits`,
}

export const filterMapping: { [key: string]: string } = {
    [EXCEPTION_FAILURE_FILTER_TYPE.SALES_ORDER]: 'salesOrderNameLike',
    [EXCEPTION_FAILURE_FILTER_TYPE.JOB_REQUEST]: 'jobNameLike',
    [EXCEPTION_FAILURE_FILTER_TYPE.MP_NAME]: 'mpNameLike',
    [EXCEPTION_FAILURE_FILTER_TYPE.EXCEPTION]: 'exceptionNameLike',
    [EXCEPTION_FAILURE_FILTER_TYPE.EXCEPTION_STATES]: 'exceptionFailureState',
    [EXCEPTION_FAILURE_FILTER_TYPE.ASSIGNEE]: 'assignee',
    [EXCEPTION_FAILURE_FILTER_TYPE.ACTIONS]: 'action',
    [EXCEPTION_FAILURE_FILTER_TYPE.CAR]: 'cars',
    [EXCEPTION_FAILURE_FILTER_TYPE.EXCEPTION_TYPE]: 'type',
    [EXCEPTION_FAILURE_FILTER_TYPE.FAILURE_TYPE]: 'type',
    [EXCEPTION_FAILURE_FILTER_TYPE.INTERNAL_FAILURE]: 'ontimeFailure',
    [EXCEPTION_FAILURE_FILTER_TYPE.EXTERNAL_FAILURE]: 'inFullFailure',
    [EXCEPTION_FAILURE_FILTER_TYPE.CREATED_BY]: 'creator',
    [EXCEPTION_FAILURE_FILTER_TYPE.MFG_DRI]: 'mpMfgDriUserIds',
    [EXCEPTION_FAILURE_FILTER_TYPE.CUSTOMER_MFG_DRI]: 'customerMfgDriUserIds',
    [EXCEPTION_FAILURE_FILTER_TYPE.JOB_STATES]: 'jobComputedStatus',
    [EXCEPTION_FAILURE_FILTER_TYPE.BUSINESS_UNIT]: 'businessUnits',
} as const

export const CAR_TYPE_MAPPING = {
    FICTIV_TYPE: 'fictiv',
    FICTIV_TITLE: 'Fictiv',
    MP_TYPE: 'mp',
    MP_TITLE: 'MP',
}

export const ExceptionTagMap: {
    [key: string]: { color: string; title: string }
} = {
    [EXCEPTION_STATUS.OPEN_EXCEPTION]: {
        color: TAG_COLORS.ORANGE,
        title: EXCEPTION_STATUS.OPEN_EXCEPTION,
    },
    [EXCEPTION_STATUS.OPEN_FAILURE]: {
        color: TAG_COLORS.ORANGE,
        title: EXCEPTION_STATUS.OPEN_FAILURE,
    },
    [EXCEPTION_STATUS.CLOSED_FAILURE]: {
        color: colors.gray2,
        title: EXCEPTION_STATUS.CLOSED_FAILURE,
    },
    [EXCEPTION_STATUS.VOIDED_EXCEPTION]: {
        color: colors.gray2,
        title: EXCEPTION_STATUS.VOIDED_EXCEPTION,
    },
    [EXCEPTION_STATUS.CLOSED_EXCEPTION]: {
        color: TAG_COLORS.GREEN,
        title: EXCEPTION_STATUS.CLOSED_EXCEPTION,
    },
}

export const EXCEPTION_FAILURES_LIST_FILTERS = {
    EXCEPTION_STATE: 'exceptionFailureState',
    TYPE: 'type',
    JOB_STATUS: 'jobComputedStatus',
    CREATOR: 'creator',
    ACTION: 'action',
    ASSIGNEE: 'assignee',
    CAR: 'cars',
    CUSTOMER_DRI: 'customerMfgDriUserIds',
    MP_DRI: 'mpMfgDriUserIds',
    BUSINESS_UNIT: 'businessUnits',
}

export const FAILURE_TYPES = [
    { LABEL: 'IF', VALUE: 'IF' },
    { LABEL: 'OT', VALUE: 'OT' },
    { LABEL: 'RFI', VALUE: 'RFI' },
] as const

export const CREATOR_FILTER = [
    {
        LABEL: 'Auto',
        VALUE: 'auto',
    },
    {
        LABEL: 'Fictiv',
        VALUE: 'fictiv',
    },
    {
        LABEL: 'MP',
        VALUE: 'mp',
    },
] as const

export const AssigneeMappingForFailures: {
    [key: string]: string
} = {
    mp: 'MP',
    sqe: 'SQE',
    quality: 'QC',
    logistics: 'Logistics',
    customer_mfg_dri: 'Customer Mfg Dri',
    logistics_shipping: 'Logistics/Shipping',
    manufacture_mfg_dri: 'Manufacturer Mfg DRI',
} as const

export const CAR_STATUS_FILTERS = [
    { LABEL: 'Pending', VALUE: 'pending' },
    { LABEL: 'Closed', VALUE: 'closed' },
    { LABEL: 'In Progress', VALUE: 'in_progress' },
    { LABEL: 'Canceled', VALUE: 'canceled' },
    { LABEL: 'Submitted', VALUE: 'submitted' },
    { LABEL: 'Approved', VALUE: 'approved' },
] as const

export const EXCEPTION_ACTIONS = {
    CREATE: 'create',
    VIEW: 'view',
    EDIT: 'edit',
}

export const JOB_STATUS_FILTERS = [
    { LABEL: 'Cancelled', VALUE: 'canceled' },
    { LABEL: 'Completed', VALUE: 'completed' },
    { LABEL: 'In primary processing', VALUE: 'in_primary_processing' },
    { LABEL: 'In secondary processing', VALUE: 'in_secondary_processing' },
    { LABEL: 'In inspection', VALUE: 'in_inspection' },
    { LABEL: 'Inspection submitted', VALUE: 'inspection_submitted' },
    { LABEL: 'Unaccepted', VALUE: 'unaccepted' },
]

export const EXCEPTION_DATE_FILTERS = [
    EXCEPTION_FAILURE_FILTER_TYPE.SHIP_DATE,
    EXCEPTION_FAILURE_FILTER_TYPE.DELIVERY_DATE,
    EXCEPTION_FAILURE_FILTER_TYPE.JOB_REQUEST_DATE,
    EXCEPTION_FAILURE_FILTER_TYPE.RECEIPT_DATE,
]
